import React, { useEffect, useState, useCallback } from "react";
import { PerformanceNavbar } from "./reusedcomponent/navbar";
import ViewAppraisal from "./modals/viewAppraisal";
import { performanceMngtThunk } from "../../../store/actions/performancemanagement/performance.thunk";
import { useDispatch, useSelector } from "react-redux";
import useModal from "../../../utils/useModal";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const EmployeeReview = () => {
  const { modalIsOpen, openModal, closeModal } = useModal();
  const [user, setUser] = useState({});
  const { yetToAppraised, appraised, events } = useSelector(
    (state) => state.performanceMngt
  );
  const dispatch = useDispatch();

  console.log("event", events);
  console.log("employeessss", appraised);

  const getEmployess = useCallback(async () => {
    await dispatch(performanceMngtThunk.getEmployeeAppraisal());
    await dispatch(performanceMngtThunk.getEvents());
  }, [dispatch]);

  // const viewEmployeeApprasial = useCallback(
  //   async (id) => {
  //     if (id) {
  //       await dispatch(performanceMngtThunk.viewEmployeeApparaised(id));
  //     }
  //   },
  //   [dispatch]
  // );

  useEffect(() => {
    getEmployess();
    // viewEmployeeApprasial();
  }, []);

  return (
    <React.Fragment>
      <PerformanceNavbar />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="create event modal"
      >
        <ViewAppraisal
          closeModal={closeModal}
          employee={user}
          eventName={events.name}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row mt-5">
            <div className="col-md-6 card">
              <div className="text-center">
                <h4 className="text-dark">Appraised</h4>
              </div>
              <div className="col-md-12">
                <table className="table table-bordered performance-review-wrapper">
                  <thead>
                    <tr>
                      <th className="th-sm">NO</th>
                      <th className="th-sm">NAME </th>
                      <th className="th-sm">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appraised.map((employee, i) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>
                          {employee.first_name.toUpperCase()}{" "}
                          {employee.last_name.toUpperCase()}
                        </td>
                        <td>
                          <button className="btn btn-block nt-button-color-default">
                            View Appraisal{" "}
                            <span className="fa fa-spinner"></span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* <div className="text-center">
                                            <p><a href="javascript:void(0)">View employees review history</a></p>
                                        </div>
                                    <div>
                                        <p className="text-center">Performance review period has not been created or not active</p>
                                    </div> */}
            </div>

            <div className="col-md-6 card">
              <div className="text-center">
                <h4 className="text-dark">Yet to be appraised</h4>
              </div>
              <div className="col-md-12">
                <table className="table table-bordered performance-review-wrapper dtMaterialDesignExample">
                  <thead>
                    <tr>
                      <th className="th-sm">NO</th>
                      <th className="th-sm">NAME </th>
                      <th className="th-sm">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {yetToAppraised.map((employee, i) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>
                          {employee.first_name.toUpperCase()}{" "}
                          {employee.last_name.toUpperCase()}
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              openModal();
                              setUser(employee);
                            }}
                            className="btn btn-block nt-button-color-default"
                          >
                            View Appraisal{" "}
                            <span className="fa fa-spinner"></span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* <div className="text-center">
                                            <p><a href="javascript:void(0)">View employees review history</a></p>
                                        </div>

                                    <div>
                                        <p className="text-center">Performance review period has not been created or not active</p>
                                    </div> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/employee_review.js